import { useDispatch, useSelector } from "react-redux";

import { dataActions } from "@src/services/state/dataReducer";
import type { RootState } from "@src/services/state/store";

/**
 * Hook for accessing and managing data state
 * Provides both selector (for reading data) and action dispatchers (for modifying data)
 */
export const useDataState = <T = RootState["data"]>(selector?: (state: RootState["data"]) => T) => {
  return useSelector((state: RootState) => {
    const dataState = state.data;
    return selector ? selector(dataState) : (dataState as T);
  });
};

/**
 * Hook for data state actions (reset, etc.)
 */
export const useData = () => {
  const dispatch = useDispatch();

  const resetData = () => {
    dispatch(dataActions.resetDataState(undefined));
  };

  return {
    resetData,
  };
};
